"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidators = getValidators;
exports.isRequired = isRequired;
exports.maxLength = maxLength;
var _validator = _interopRequireDefault(require("validator"));
function isRequired(value) {
  if (value === true || value === false) {
    return value;
  }
  return !_validator["default"].isEmpty(_.toString(value), {
    ignore_whitespace: true
  });
}
function maxLength(value, length) {
  return _validator["default"].isLength(value, {
    max: length
  });
}
var validators = {
  email: {
    func: _validator["default"].isEmail,
    message: "Enter a valid email address."
  },
  required: {
    func: isRequired,
    message: "This field is required."
  },
  maxLength: {
    func: maxLength,
    message: function message(length) {
      return "This field must not contain more than ".concat(length, " characters.");
    }
  }
};
function getValidators(options) {
  return function (value) {
    for (var index in options) {
      if (options.hasOwnProperty(index)) {
        var validator_name = options[index];
        var validator_option = undefined;
        if (_.isArray(validator_name)) {
          validator_name = validator_name[0];
          validator_option = validator_name[1];
        }
        var validator_info = validators[validator_name];
        value = value === undefined ? "" : value;
        var result = validator_option === undefined ? validator_info.func(value) : validator_info.func(value, validator_option);
        if (!result) {
          if (_.isFunction(validator_info.message)) {
            return validator_info.message(validator_option);
          }
          return validator_info.message;
        }
      }
    }
  };
}